import Layout from '../layouts/Layout'
import Main from '../components/Settings/Main'

const Settings = () => {
  return (
    <Layout>
      <Main />
    </Layout>
  )
}

export default Settings